import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getMunicipality, INCUMBENTS } from "../data/site";

const initials = (name) =>
    name
        .split(" ")
        .filter(Boolean)
        .map((p) => p[0])
        .slice(0, 2)
        .join("");

export const CandidateCard = ({ candidate }) => {
    const m = getMunicipality(candidate.municipality);
    return (
        <Link
            to={`/candidates/${candidate.slug}`}
            data-testid={`candidate-card-${candidate.slug}`}
            className="group flex h-full flex-col border border-border bg-white p-6 transition-all hover:-translate-y-0.5 hover:border-gold hover:shadow-md"
        >
            <div className="flex items-start justify-between">
                <div className="flex h-14 w-14 items-center justify-center bg-navy font-serif-display text-xl font-bold text-gold">
                    {initials(candidate.name)}
                </div>
                {INCUMBENTS.includes(candidate.slug) && (
                    <span
                        data-testid={`incumbent-badge-${candidate.slug}`}
                        className="border border-gold bg-navy px-2 py-0.5 text-[10px] font-semibold uppercase tracking-widest text-gold"
                    >
                        Incumbent
                    </span>
                )}
            </div>
            <h3 className="mt-4 font-serif-display text-xl font-semibold text-navy">
                {candidate.name}
            </h3>
            <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-teal">
                Candidate for {candidate.office}
            </p>
            {candidate.editorialTitle && (
                <p className="mt-3 font-serif-display text-sm italic text-muted-foreground">
                    {candidate.editorialTitle}
                </p>
            )}
            <span className="mt-auto inline-flex items-center gap-1 pt-4 text-sm font-semibold text-navy transition-colors group-hover:text-teal">
                Read the profile
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
            </span>
        </Link>
    );
};
